import { Category } from '@/types';
import { useMemo } from 'react';

export const useCategorySelectors = (categories: Category[]) => {
  return useMemo(() => ({
    getById: (id: string) =>
      categories.find(c => c.id === id),
    
    getByType: (type: 'receita' | 'despesa') =>
      categories.filter(c => c.type === type),
    
    getDefault: () =>
      categories.filter(c => c.isDefault),
    
    getCustom: () =>
      categories.filter(c => !c.isDefault),
    
    getByName: (name: string) =>
      categories.find(c => c.name.toLowerCase() === name.toLowerCase()),
  }), [categories]);
};
